import { Navigate, useLocation, useParams } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../hooks/useAuth";

interface AdminAuthGuardProps {
  children: ReactNode;
}

export function AdminAuthGuard({ children }: AdminAuthGuardProps): ReactNode {
  const { user, loading } = useAuth();
  const { tenant } = useParams<{ tenant: string }>();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 dark:bg-slate-900">
        <p className="text-sm text-slate-600 dark:text-slate-300">Lade Anmeldung …</p>
      </div>
    );
  }

  if (!user) {
    const loginPath = tenant !== undefined ? `/${tenant}/admin/login` : "/";
    return (
      <Navigate
        to={loginPath}
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}
